import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiProvider } from './api-provider';
import { User } from 'src/app/micro-services/user/models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthProviderService extends ApiProvider{

  createCoach(coach: User): Observable<boolean> {
    const url = this.getApiUrlCall('api/authenticate/register-coach');
    return this.http.post<boolean>(url, coach);
  }

  forgotPassword(email: string): Observable<boolean> {
    const url = this.getApiUrlCall('api/forgot/ForgotPassword');
    return this.http.post<boolean>(url, { Email : email });
  }

}
